export default __webpack_public_path__ + "static/media/icon_logout.a3b9c133.svg";